import { render, staticRenderFns } from "./MessageVideo.vue?vue&type=template&id=4550fb7e&"
import script from "./MessageVideo.vue?vue&type=script&lang=js&"
export * from "./MessageVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports